export default "https://cdn-static.gokick.com/assets/528ec2ebd6131ff545f204827e0544e2c800444b/images/two-pack.1e6632cffb735562eaf44e7ebc36435e.png";